var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestTabletRepin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 9,
  viewBox: "0 0 11 9",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4.654.9v.9s-.846.58-.872.93c.002.132.005.343.01.565l.004.268.012.667s.683.376.753.52c.353.546.516 1.55.516 1.55H2.962L2.5 9l-.385-2.7H0s.21-1.032.526-1.549c.107-.173.743-.521.743-.521s.02-1.09.024-1.475c.003-.312-.87-.955-.87-.955V.9zM8.5 0l.385 2.7H11s-.21 1.032-.526 1.549c-.107.173-.743.521-.743.521s-.02 1.09-.024 1.475c-.003.312.87.955.87.955v.9h-4.23v-.9s.845-.58.871-.93c-.002-.132-.005-.343-.01-.565l-.004-.268-.012-.667s-.683-.376-.753-.52c-.353-.546-.516-1.55-.516-1.55h2.115z"
})));
export default SvgPinterestTabletRepin;